<template>
    <div>
        Regulamin
    </div>
</template>

<script setup>

</script>

<style lang="scss" scoped></style>
